import UserLayout from '@/components/Layouts/User';

import Primary from './Primary';
import Secondary from './Secondary';

const TrackingClients = () => {
  return (
    <UserLayout>
      <Secondary />
      <Primary />
    </UserLayout>
  );
};

export default TrackingClients;
